import React from 'react';
import PropTypes from 'prop-types';

const Strings = require('../../../../../app/shared/Strings');
const StringUtil = require('../../../../../app/shared/StringUtil');
const C3ColorUtil = require('../../../util/C3ColorUtil');
import DonutChart from '../../chart/DonutChart';
import BarChart from '../../chart/BarChart';

const propTypes = {
	id: PropTypes.string,
	className: PropTypes.string,
	chartType: PropTypes.oneOf(['donut', 'bar']),
    chartWidth: PropTypes.number,
    chartHeight: PropTypes.number,
    chartAlign: PropTypes.oneOf(['left', 'center']),
	onChangeChartType: PropTypes.func.isRequired,
    loUsage: PropTypes.arrayOf(PropTypes.shape({
    	id: PropTypes.string.isRequired,
    	title: PropTypes.string,
    	graph_data: PropTypes.array.isRequired,
    	summary_stat: PropTypes.string,
    })),
};
const defaultProps = {
	id: 'charts-qla-lo',
	className: '',
    chartWidth: 185,
    chartHeight: 185,
    chartAlign: 'center',
	loUsage: [],
};

export default function QLALOCharts(props) {
	let charts;
	let chartRowClass;
	let extraChartClasses = '';
	const scoreColorsObj = C3ColorUtil.getScoreRangeColorObj();
	const scoreLabelColorsObj = C3ColorUtil.getScoreRangeLabelColorObj();
	const labelRatio = 1;
	const selectorUI = (
		<label htmlFor={`${props.id}-type-select`}>
			{Strings['en'].activity.qla.charts.CH_TYPE}
			<div id={`${props.id}-type-select`} className="margin-top-md" role="radiogroup">
					<div className="inline-block margin-right-lg">
                        <input
                            id={`${props.id}-type-select-donut`}
                            type="radio"
                            value="donut"
                            checked={props.chartType === 'donut'}
                            onChange={props.onChangeChartType}
                        />
                        <label className="block" htmlFor={`${props.id}-type-select-donut`}>
                        	{Strings['en'].activity.qla.charts.CH_TYPE_PIE}
                        </label>
                    </div>

                    <div className="inline-block">
                        <input
                            id={`${props.id}-type-select-bar`}
                            type="radio"
                            value="bar"
                            checked={props.chartType === 'bar'}
                            onChange={props.onChangeChartType}
                        />
                        <label className="block" htmlFor={`${props.id}-type-select-bar`}>
                        	{Strings['en'].activity.qla.charts.CH_TYPE_BAR}
                        </label>
                    </div>
            </div>
        </label>
	);

	if (props.chartAlign === 'left') {
		chartRowClass = 'qlaOverallChartRow--left';
		extraChartClasses = 'qlaLeftChart';
	}
	else if (props.chartAlign === 'center') {
		chartRowClass = 'qlaOverallChartRow';
	}
	else {
		chartRowClass = 'qlaOverallChartRow';
	}

	if (props.chartType === 'donut') {
		charts = (
			<div className={chartRowClass}>
				{props.loUsage.map((loData) => (
		            <DonutChart
		            	key={loData.id}
			            id={`qlalo-donut-${loData.id}`}
			            className={extraChartClasses}
			            chartClassName="mzl-bb-donut-sm-label"
			            width={props.chartWidth}
			            height={props.chartHeight}
			            title={loData.title}
			            columns={loData.graph_data}
			            colors={scoreColorsObj}
			            labelColors={scoreLabelColorsObj}
			            labelRatio={labelRatio}
			            summaryStat={loData.summary_stat}
				        tooltip={Strings['en'].activity.qla.charts.CH_TT_LO}
		            />
				))}
		        {selectorUI}
			</div>
		);
	}
	else if (props.chartType === 'bar') {
		charts = (
			<div className={chartRowClass}>
				{props.loUsage.map((loData) => (
		            <BarChart
		            	key={loData.id}
		            	className={extraChartClasses}
			            id={`qlalo-bar-${loData.id}`}
			            removeXTick
			            yInt
			            xAxisType="category"
			            width={props.chartWidth}
			            height={props.chartHeight}
			            title={loData.title}
			            columns={loData.graph_data}
			            colors={scoreColorsObj}
			            summaryStat={loData.summary_stat}
			            tooltip={Strings['en'].activity.qla.charts.CH_TT_LO}
		            />
				))}
		        {selectorUI}
			</div>
		);

	}
	else {
		return null;
	}

	return (
		<div id={props.id} className={props.className}>
			{charts}
		</div>
	)	
}

QLALOCharts.propTypes = propTypes;
QLALOCharts.defaultProps = defaultProps;